import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'sumarCampo'
})
export class SumarCampoPipe implements PipeTransform {

	transform(value: any[], nombreCampo: string): number {
		let Suma: number = 0;

		//Valido que no sea nulo
		if (value) {
			//Valido que tenga elementos en la lista
			if (value.length > 0) {
				//Valido que existe el campo.
				if (value[0][nombreCampo]) {
					value.forEach(x => Suma = Suma + x[nombreCampo]);
				}
			}
		}

		return Suma;
	}

}